import type { Route } from 'next';

export function buildBoardPath(rowId: string, slug: string, path: string | null | undefined) {
	if (slug === '/') {
		return slug as Route;
	}

	if (path) {
		return `${path},${rowId}` as Route;
	}

	return `${slug},${rowId}` as Route;
}
